/*
 * What a pop-up campaign's button does. Either it opens a link, or it buys a
 * package — then `actionUrl` holds no outside address but the dashboard's own
 * packages page with the package to buy, and the dashboard (not the admin)
 * builds the PayPro checkout for the user signed in, as its packages page
 * does: the current product and price, the user's uid, the package id. No
 * backend change: it is still the same `actionUrl` string.
 *
 *   /packages?buy=12&billing=monthly
 *   /packages/webinthub?buy=31&billing=annual
 *
 * espy-dashboard has a copy (function/campaign/campaignAction.ts); its
 * PopupCampaign opens the checkout (function/payment.ts packageCheckoutUrl),
 * or the packages page when that package cannot be bought there.
 */

export type Billing = 'monthly' | 'annual'
export type BuyAction = { packageId: number; billing: Billing; webint: boolean }

const BUY = /^\/packages(\/webinthub|\/general)?\?buy=(\d+)(?:&billing=(monthly|annual))?$/

export function parseBuyAction(actionUrl: string | null | undefined): BuyAction | null {
  const m = (actionUrl || '').trim().match(BUY)
  if (!m) return null
  return { packageId: Number(m[2]), billing: m[3] === 'annual' ? 'annual' : 'monthly', webint: m[1] === '/webinthub' }
}

export const buyActionUrl = ({ packageId, billing, webint }: BuyAction) =>
  `/packages${webint ? '/webinthub' : ''}?buy=${packageId}&billing=${billing}`
